"use client";

import { useState } from "react";
import { FaLine } from "react-icons/fa6";
import { HiOutlineMenu, HiX } from "react-icons/hi";

export const NavigationBar = ({ lineUrl }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 border-b border-gold/10 bg-cream/80 backdrop-blur"
    >
      <div className="mx-auto flex max-w-md items-center justify-between px-6 py-4 md:max-w-4xl md:px-12 lg:max-w-6xl">
        
        {/* Brand Section */}
        <div className="flex items-center gap-3">
          <img
            src="/images/sai-logo.jpg"
            alt="Sense Your Soul Logo"
            className="h-16 w-16 rounded-full object-cover shadow-md ring-2 ring-gold/30"
          />

          <div className="space-y-1">
            <p className="font-serif text-lg text-taupe">
              Sense Your Soul
            </p>
            <p className="text-xs text-taupeLight">
              ดูดวงกับทราย
            </p>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden items-center gap-6 text-sm text-taupeLight md:flex">
          <a href="#triggers" className="hover:text-taupe">
            เรื่องที่กังวล
          </a>
          <a href="#about" className="hover:text-taupe">
            เกี่ยวกับเรา
          </a>
          <a href="#pricing" className="hover:text-taupe">
            ราคา
          </a>
          <a href="#testimonials" className="hover:text-taupe">
            รีวิวจริง
          </a>
        </nav>

        {/* Desktop LINE Button */}
        <a
          href={lineUrl}
          target="_blank"
          rel="noreferrer"
          className="hidden items-center gap-2 rounded-full bg-line px-4 py-2 text-xs font-semibold text-white shadow-glow-line transition hover:shadow-[0_0_20px_rgba(0,195,0,0.7)] md:inline-flex"
        >
          <FaLine className="text-sm" />
          ทัก LINE
        </a>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-taupe"
        >
          {isOpen ? (
            <HiX className="h-6 w-6" />
          ) : (
            <HiOutlineMenu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden border-t border-gold/10 bg-cream px-6 pb-6 pt-4 space-y-4 text-sm text-taupeLight animate-fadeIn">
          
          <a href="#triggers" onClick={() => setIsOpen(false)} className="block">
            เรื่องที่กังวล
          </a>
          <a href="#about" onClick={() => setIsOpen(false)} className="block">
            เกี่ยวกับเรา
          </a>
          <a href="#pricing" onClick={() => setIsOpen(false)} className="block">
            ราคา
          </a>
          <a href="#testimonials" onClick={() => setIsOpen(false)} className="block">
            รีวิวจริง
          </a>

          {/* Mobile LINE Button */}
          <a
            href={lineUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full bg-line px-4 py-3 text-sm font-semibold text-white shadow-glow-line"
          >
            <FaLine />
            ทัก LINE ตอนนี้
          </a>
        </div>
      )}
    </header>
  );
};